var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobViewsCountesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.103,
    height: 10.715,
    viewBox: "0 0 18.103 10.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_17406116",
    transform: "translate(-2.5 -21.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39883",
    "data-name": "Path 39883",
    d: "M39.953,37.391a2.558,2.558,0,1,0,2.558,2.558A2.561,2.561,0,0,0,39.953,37.391Z",
    transform: "translate(-28.401 -12.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39884",
    "data-name": "Path 39884",
    d: "M20.418,26.7a11.147,11.147,0,0,0-8.866-4.817A11.162,11.162,0,0,0,2.681,26.7a.891.891,0,0,0,0,1.076A11.154,11.154,0,0,0,11.552,32.6a11.147,11.147,0,0,0,8.866-4.817.884.884,0,0,0,0-1.081Zm-8.866,4.112a3.572,3.572,0,1,1,3.572-3.572,3.576,3.576,0,0,1-3.572,3.572Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobViewsCountesIcon);
export default __webpack_public_path__ + "static/media/job_views_Countes_Icon.b5a5b777397e548b25da29269af102c2.svg";
export { ForwardRef as ReactComponent };